import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

export function StatCard({ title, metric, sub, icon: Icon, accent, onClick, active, testId }) {
  return (
    <Card
      data-testid={testId}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } } : undefined}
      className={cn(
        "p-5",
        onClick && "cursor-pointer transition-[box-shadow,transform,border-color] hover:-translate-y-0.5 hover:shadow-md",
        active && "border-[#022a51] ring-2 ring-[#022a51]/20 dark:border-sky-400 dark:ring-sky-400/20",
      )}
    >
      <div className="flex items-start justify-between">
        <div className="font-mono text-xs uppercase tracking-wider text-muted-foreground">{title}</div>
        {Icon && (
          <div className={cn("flex h-8 w-8 items-center justify-center rounded-lg", accent || "bg-secondary")}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="mt-3 font-heading text-2xl font-extrabold tracking-tight tabular">{metric}</div>
      {sub && <div className="mt-1 text-sm text-muted-foreground">{sub}</div>}
    </Card>
  );
}
